import { useMemo, useCallback } from 'react';
import { useApi } from '../../provider';
import { useQuery } from '../../hooks';
import { MetricsService } from './service';
import { FacilityQTAStatusCounts, Metrics } from './types';

const CACHE_KEY = 'metrics';

export function useMetrics() {
  const api = useApi();
  const service = useMemo(() => new MetricsService(api), [api]);
  const fetcher = useCallback(() => service.getAll(), [service]);

  return useQuery<Metrics>(CACHE_KEY, fetcher, {
    // TODO: Caching is currently disabled. Enable after backend implementation.
    // Cache TTL is set to 5 minutes (default) but can be adjusted based on data refresh requirements.
    enabled: true,
  });
}

export function useFacilityQTAStatusCounts() {
  const api = useApi();
  const service = useMemo(() => new MetricsService(api), [api]);
  const fetcher = useCallback(
    () => service.getFacilityQTAStatusCounts(),
    [service]
  );

  return useQuery<FacilityQTAStatusCounts>(
    `${CACHE_KEY}-facility-qta-status-counts`,
    fetcher,
    {
      enabled: true,
    }
  );
}
